// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8afc4bdd","488":"e2241394"}[chunkId] + ".chunk.js";
};